import { CustomButton } from '@/components/atoms/CustomButton';
import Modal from '@/components/atoms/Modal';
import classes from './styles.module.scss';
import { CommEvent } from '@/hooks/socket';

type RestartPopupProps = {
  deviceCode: string;
  events: CommEvent;
  isOk: boolean;
};
export const RestartPopup = ({
  deviceCode,
  events,
  isOk,
}: RestartPopupProps) => {
  const handleRestart = () => {
    events.sendToEvent('restart-device', {
      deviceCode,
    });
  };

  return (
    <div className={classes.restartPopup}>
      <Modal
        trigger={
          <CustomButton className={classes.restartButton} color="error">
            親機(実機)再起動
          </CustomButton>
        }
        footer={({ close }) => (
          <div className={classes.footer}>
            <CustomButton
              onClick={close}
              variant="outlined"
              color="error"
              style={{ marginRight: '8px' }}
            >
              キャンセル
            </CustomButton>
            <CustomButton
              onClick={() => {
                handleRestart();
                close();
              }}
              variant="contained"
              color="primary"
              disabled={!isOk}
            >
              はい
            </CustomButton>
          </div>
        )}
      >
        <p className={classes.content}>
          親機（実機）を再起動します。起動には約７分掛かります。よろしいですか？　[はい][キャンセル]
        </p>
      </Modal>
    </div>
  );
};
